import axios from "../../utils/axios";

export const getBlogById = async (id) => {
  const response = await axios.get(`blogs/${id}`);
  return response.data;
};

export const updateLikes = async (updatedData) => {
  const {likes, id, isSaved} = updatedData;

  let response;
  if (likes) {
    response = await axios.patch(`/blogs/${id}`, {
      likes: likes + 1,
    });
  }else{
    response = await axios.patch(`/blogs/${id}`,{isSaved: !isSaved})
  }
  return response.data
};
